import Condition from './condition/Condition'
import AiConditionPanel from './condition/AiConditionPanel'
import WaitPanel from './wait/WaitPanel'
import End from './end/End'
import LoopPanel from './loop/loop'
import OutputPanel from './output/Output'
import AiActionPanel from './output/AiActionPanel'

export default function (panel) {
    // In AI-code mode the "if" condition and "output" action use the AppMode
    // ProgrammingPage model (camera/speech/USB detections + Display action),
    // not the flowchart's hardware sensor/output panels.
    const aiCodeMode = sessionStorage.getItem('webAiMode') === 'true'

    switch (panel) {
        case 'condition':
            return aiCodeMode ? AiConditionPanel : Condition
        case 'wait':
            return WaitPanel
        case 'loop':
            return LoopPanel
        case 'output':
            return aiCodeMode ? AiActionPanel : OutputPanel
        case 'repeat':
        case 'end':
            return End
    }
}
